const reservationList = {
    init: () => {
        $.getJSON(urlHelper.qualifyURL('Reservation/GetReservations'), function (data) {
            reservationList.initPaginator('#own-reservations', data.ownReservations);
            reservationList.initPaginator('#other-reservations', data.otherPersonReservations);
        });
    },

    initPaginator: function initPaginator(parentSelector, data) {
        var $parent = $(parentSelector);
        var $nav = $parent.children('.btn__list__paginator');
        var $target = $parent.children('.btn__list__container');
        $nav.pagination({
            className: 'paginationjs-theme-custom',
            dataSource: data,
            callback: function (data, pagination) {
                console.log(data);
                reservationList.render(data, $target);
            }
        })
    },

    render: function render(data, $target) {
        var template = document.getElementById('row-template').innerHTML;

        var html = Mustache.render(template, data);
        $target.html(html);
        reservationList.bindCancelButtons();
    },

    bindCancelButtons: function bindCancelButtons() {
        $('.btn-cancel').click(reservationList.cancelReservationClick);
    },

    cancelReservationClick: function cancelReservation(e) {
        var $parent = $(this).closest('.btn__list__item');
        if (!$parent[0])
            $parent = $(this).closest('.btn__table__item');

        var id = $parent.attr('data-id');
        var guid = $parent.attr('data-guid');
        var fullName = $parent.attr('data-fullname');
        var dateFrom = $parent.attr('data-date');

        reservationList.renderModal({ id, guid, fullName, dateFrom }, $('#modal-cancel'))

        var url = 'Reservation/CancelReservation?id=' + id + '&guid=' + guid;
        $('#modal-cancel #cancel-link').prop('href', url);
        $('#modal-cancel').modal();
    },

    renderModal: function renderModal(data, $target) {
        var modalTemplate = document.getElementById('modal-content-template').innerHTML;

        var html = Mustache.render(modalTemplate, data);
        $target.html(html);
    }
};